/**
 * 再資源化処分方法
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const search_recycle_disposal_method = {
  namespaced: true,
  state: () => ({}),
  getters: {},
  actions: {

    /**
     * 再資源化処分方法一覧取得
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(`${httpConst.DRIVER_ENDPOINT}/masters/search/recycle_disposal_methods`).then(data => {
          const content = data.content;
          resolve(content)
        })
      })
    },
  },
  mutations: {},
}

export default search_recycle_disposal_method
